import Vue from 'vue'
import Router from 'vue-router'
// import Landing from './views/Landing'

Vue.use(Router)

export default new Router({
    mode: 'history',
    //GoDaddy:
    // base: 'dev/3m-tradeup-v4', //Only have this in for deployment
    base: 'client',

    //If you have a base URL, you will need to update the favicon bathing to "<%= BASE_URL %>favicon.ico"
    routes: [
        {
            path: '*',
            name: 'Landing Page Default', 
            redirect: `/en`,
            component: () =>
            import ('./views/Landing'),
        },
        {
            path: '/:lang', 
            component: { render (c) { return c('router-view') } },
            beforeEnter (to, from, next) {
                const lang = to.params.lang
                if(!['en', 'en_us', 'fr'].includes(lang)) return next('en')
                return next();
            },
            children:[
                {
                    path: '',
                    name: 'Landing Page',
                    component: () =>
                        import ('./views/Landing')
                },
                {
                    path: 'auth',
                    name: 'auth',
                    component: () =>
                        import ('./views/Auth')
                },
                {
                    path: 'downloads',
                    name: 'downloads',
                    component: () =>
                        import ('./views/Downloads')
                },
                {
                    path: 'start',
                    name: 'Start',
                    component: () =>
                        import ('./views/Start')
                },
                {
                    path: 'presentation',
                    name: 'Presentation',
                    component: () =>
                        import ('./views/Presentation')
                },
            ]
        },




    ]
})

